<div class="price-set-container">
    <div class="cal-header">
        <div>
            @if (pid) {
                <span
                    class="dx-icon-link icon"
                    title="เชื่อมต่อข้อมูลแล้ว"
                ></span>
                <span class="product-link-tag"># {{ pid }}</span>
                <span class="product-link-tag">{{ code }}</span>
            } @else {
                <span class="muted">รอข้อมูลสินค้าจากหน้า lnwshop ...</span>
            }
        </div>
        <div class="text-link-container">
            <a [routerLink]="['/embeded/price-cal']">← เครื่องคิดเลข</a>
        </div>
    </div>

    <hr />

    <div class="calc-row">
        <label
            title="ราคาหลักของสินค้าบนเว็บ LnwShop — ตัวตั้งของทุกช่อง (LINE Shopping ตามราคานี้โดยตรง) · ค่าเริ่มต้น = ราคาขาย LS จากเครื่องคิดเลข หรือราคาหลักปัจจุบัน"
            >ราคาหลัก LnwShop</label
        >
        <div class="input-group">
            <input
                type="number"
                min="0"
                step="1"
                [value]="baseInput"
                (input)="onBaseChange($any($event.target).value)"
                [class.changed]="baseChanged"
                [disabled]="!pid || applying"
            />
            <span>บาท</span>
        </div>
    </div>
    @if (currentBase !== null) {
        <div class="calc-row sub">
            <label>ปัจจุบัน {{ currentBase | formatNumber: 2 }}</label>
            @if (!canEditBase) {
                <span class="warn"
                    >ราคาหลักล็อก (ตามสินค้าแม่) — ตั้งเฉพาะช่องทาง</span
                >
            }
        </div>
    }

    <div class="calc-row">
        <label
            title="ตัวตั้งของกฎทุกช่อง — ค่าเริ่มต้นจากสูตรเครื่องคิดเลข: ราคาหลัก × (1 − VAT/107) ÷ (1 − ค่าธรรมเนียม − VAT/107) ปัดขึ้น · แก้ทับได้ แล้วช่องอื่นคิดจากค่าที่แก้"
            >{{ GENERAL4.label }}</label
        >
        <div class="input-group">
            <input
                type="number"
                min="0"
                step="1"
                [value]="general4Input"
                (input)="onGeneral4Change($any($event.target).value)"
                [class.changed]="general4Changed"
                [disabled]="!pid || applying"
            />
            <span>บาท</span>
        </div>
    </div>
    <div class="calc-row sub">
        <label>
            ปัจจุบัน
            {{
                currentGeneral4 === null
                    ? "—"
                    : (currentGeneral4 | formatNumber: 2)
            }}
            · สูตร ค่าธรรมเนียม {{ platformFeePct }}% + VAT {{ vatPct }}%
        </label>
    </div>

    <hr />

    <table class="plan">
        <thead>
            <tr>
                <th>ช่อง</th>
                <th>กฎ</th>
                <th class="num">ปัจจุบัน</th>
                <th class="num">ใหม่</th>
            </tr>
        </thead>
        <tbody>
            @for (p of plan; track p.instance) {
                <tr [class.unchanged]="!p.changed" [class.unlisted]="!p.listed">
                    <td
                        [title]="
                            p.listed
                                ? ''
                                : 'ยังไม่ได้ list บน marketplace — ตั้งค้างไว้ใน lnwshop'
                        "
                    >
                        {{ p.label }}
                        @if (!p.listed) {
                            <span class="muted"> (ยังไม่ list)</span>
                        }
                    </td>
                    <td class="muted">{{ p.rule }}</td>
                    <td class="num">
                        {{
                            p.current === null
                                ? "ช่วง"
                                : (p.current | formatNumber: 2)
                        }}
                    </td>
                    <td class="num" [class.font-bold]="p.changed">
                        {{ p.next | formatNumber: 2 }}
                        @if (p.kind === "sync") {
                            <span
                                class="muted"
                                title="ตั้งแท็บให้ใช้ราคาขายเหมือน LnwShop"
                            >
                                sync</span
                            >
                        }
                    </td>
                </tr>
            } @empty {
                <tr>
                    <td colspan="4" class="muted">กรอกราคาหลักก่อน</td>
                </tr>
            }
        </tbody>
    </table>

    <hr />

    <div class="actions">
        <button
            class="apply"
            (click)="apply()"
            [disabled]="!pid || applying || changedCount === 0"
        >
            ตั้งราคาบนหน้า ({{ changedCount }} รายการ)
        </button>
        <span class="muted"
            >กรอกลงฟอร์มอย่างเดียว — ตรวจแล้วกด "บันทึก" ของ lnwshop เอง</span
        >
    </div>

    @if (statusText) {
        <div class="status">
            @if (applying) {
                <span class="dx-icon-refresh"></span>
            }
            {{ statusText }}
        </div>
    }
    @if (results) {
        <ul class="results">
            @for (r of results; track r.target) {
                <li [class.ok]="r.ok" [class.fail]="!r.ok">
                    <span>{{ r.ok ? "✓" : "✗" }}</span> <b>{{ r.label }}</b> —
                    {{ r.message }}
                </li>
            }
        </ul>
    }
</div>
